import { DEFAULT_THEME } from "./defaultTheme";

export const THEMES = {
  ...DEFAULT_THEME,
};
